import { CHART_DIMENSIONS } from '../shared/chart-tokens';

const TICK_HEIGHT = 20;
const FALLBACK_TICK_WIDTH = 100;

interface TickPayload {
  value?: string;
}

export interface BarChartTickProps {
  x?: number;
  y?: number;
  payload?: TickPayload;
  /** Total XAxis pixel width. Injected by Recharts. */
  width?: number;
  /** Total tick count. Injected by Recharts. */
  visibleTicksCount?: number;
}

/** Computes the pixel width available for a single tick label. */
const computeTickLabelWidth = (
  axisWidth: number | undefined,
  visibleTicksCount: number | undefined
): number => {
  if (
    axisWidth === undefined ||
    visibleTicksCount === undefined ||
    visibleTicksCount <= 0
  ) {
    return FALLBACK_TICK_WIDTH;
  }

  const slotWidth = axisWidth / visibleTicksCount;

  return Math.max(slotWidth - CHART_DIMENSIONS.xAxisLabelGap, 0);
};

export const BarChartTick = ({
  x = 0,
  y = 0,
  payload,
  width: axisWidth,
  visibleTicksCount,
}: BarChartTickProps) => {
  const fullLabel = payload?.value?.trim() ?? '';

  if (!fullLabel) return null;

  const tickWidth = computeTickLabelWidth(axisWidth, visibleTicksCount);

  return (
    <g transform={`translate(${x}, ${y})`}>
      <foreignObject
        x={-tickWidth / 2}
        y={0}
        width={tickWidth}
        height={TICK_HEIGHT}
      >
        <div
          title={fullLabel}
          className="font-text text-xs text-center text-gray-500 truncate"
        >
          {fullLabel}
        </div>
      </foreignObject>
    </g>
  );
};
